window.addEventListener('DOMContentLoaded', function() {

    // Case Studies Slider
    let caseStudiesSlider = this.document.getElementById('case-studies-slider');

    if (caseStudiesSlider) {
        let textContainer = this.document.querySelector('.home-case-studies .text-container');
        let textElements = textContainer.querySelectorAll('.text');

        $(caseStudiesSlider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            let parentSection = caseStudiesSlider.closest('.home-case-studies');
            let activeChild = parentSection.querySelector(`.text.active`);
            let matchingChild = parentSection.querySelector(`[data-index="${nextSlide+1}"]`);

            activeChild.classList.remove('active');
            activeChild.classList.add('inactive');

            matchingChild.classList.add('active');
            matchingChild.classList.remove('inactive');
        });

        $(caseStudiesSlider).slick({
            arrows: true,
            dots: true,
            infinite: true,
            speed: 400,
            slidesToShow: 1,
            slidesToScroll: 1
        });

        resizeTextContainer();
        window.addEventListener('resize', resizeTextContainer);

        function resizeTextContainer(){
            if (textContainer && textElements.length > 0) {
                let maxHeight = 0;
        
                textElements.forEach(function(textElement) {
                    let elementHeight = textElement.offsetHeight;
                    if (elementHeight > maxHeight) {
                        maxHeight = elementHeight;
                    }
                });
        
                textContainer.style.height = `${maxHeight}px`;
                textContainer.classList.add('loaded');
            }
        }
    }

    // SHOP BY USE SLIDER
    let shopBySlider = this.document.querySelector('.home-shop-by .slides');
    let hiddenSlides = this.document.querySelectorAll('.hidden-slides .slide');

    if(shopBySlider) {

        let sliderSettings = {
            arrows: true,
            dots: false,
            infinite: false,
            speed: 400,
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: '#arrow-next',
            prevArrow: '#arrow-prev',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, 
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },            
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        $(shopBySlider).slick(sliderSettings);

        // TOGGLE SLIDE TYPE
        let collectionTypeSelect = this.document.getElementById('select-slide-type');
        let collectionType = collectionTypeSelect.querySelectorAll('#select-slide-type .option');

        collectionTypeSelect.addEventListener('click', function() {
            if (collectionTypeSelect.classList.contains('open')) {
                collectionTypeSelect.classList.remove('open');
            } else {
                collectionTypeSelect.classList.add('open');
            }
        });

        document.addEventListener('click', function(event) {
            if (!collectionTypeSelect.contains(event.target)) {
                collectionTypeSelect.classList.remove('open');
            }
        });

        collectionType.forEach(function(option) {
            option.addEventListener('click', function() {

                if(option.classList.contains('selected')) {
                    return;
                }
                
                collectionTypeSelect.classList.add('hide-options');

                collectionType.forEach(function(opt) {
                    opt.classList.remove('selected');
                });
                option.classList.add('selected');
                option.blur();

                setTimeout(function() {
                    collectionTypeSelect.classList.remove('hide-options');
                }, 200);
                
                let slides = shopBySlider.querySelectorAll('.slide');
                let activeSlideType = option.dataset.value;
                
                shopBySlider.classList.add('fade-out');

                setTimeout(function() {
                    $(shopBySlider).slick('unslick');

                    shopBySlider.innerHTML = '';

                    hiddenSlides.forEach(function(hiddenSlide) {
                        if (hiddenSlide.classList.contains(`slide--${activeSlideType}`)) {
                            shopBySlider.appendChild(hiddenSlide.cloneNode(true));
                        }
                    });
            
                    $(shopBySlider).slick(sliderSettings);

                    shopBySlider.classList.remove('fade-out');
                }, 500);

            });
        });
    }
});